<template>
  <div class="preview-container" 
        @dblclick="selectAll" >
      <div 
        v-for="(f,i) of this.files" 
        :key="i" 
        :data-preview-num="i" 
        @click.shift="previewShiftClick"
        @click.ctrl="previewCtrlClick"
        @click.exact="previewClick" 
        @dblclick="selectAll" 
        class="preview" 
        :class="{'preview-selected':selected.includes(i)}"
        >
        <slot name="preview" :file="f"/>
      </div>
    </div>
</template>

<script>
export default {
    props:["files"],
    data(){return {
        selected:[]
    }},
    methods:{
        previewClick(e){
        let clicked= parseInt(e.target.closest(".preview").getAttribute("data-preview-num"))
        if(this.selected == clicked) this.selected = []
        else this.selected = [clicked]
        },
        previewShiftClick(e){
            let clicked= parseInt(e.target.closest(".preview").getAttribute("data-preview-num"))
            if(this.selected.length == 1){
                let upper = Math.max(this.selected[0], clicked)
                let lower = Math.min(this.selected[0], clicked)
                this.selected = []
                let c =   upper - lower + 1;
                while ( c-- ) this.selected[c] = upper--
            } else this.selected = [];
        },
        previewCtrlClick(e){
             let clicked= parseInt(e.target.closest(".preview").getAttribute("data-preview-num"))
             if(this.selected.includes(clicked)){
                 this.selected.splice(this.selected.indexOf(clicked),1)
             } else this.selected.push(clicked)
        },
        selectAll(){ 
          if(this.selected.length === this.files.length) this.selected = [];
          else this.selected = this.files.map((_,i) => i) 
        }
    },
    watch:{
        selected(newVal){
          let fs = newVal.map((i) => this.files[i])
          this.$emit('input', fs)
        }
    }
}
</script>

<style>
.thumbnail {
  width:10em;
  height: auto;
}

.preview-container {
  display: grid;
  grid-gap:1em;
  grid-template-columns: repeat(auto-fill, minmax(12em, 1fr));
  grid-auto-flow: dense;
  max-width: 100%;
  justify-items: center;
  user-select: none;

}

.preview {
  display: grid;
  grid-template-rows: auto auto;
  place-content: center;
  justify-items: center;
  border:1px solid white;
  border-radius: 0.2em;
  box-sizing: border-box;
  cursor: pointer;
  padding:0.75em;
  font-size: 0.8em;
  max-width: 12em;
}

.preview > div {
    max-width: inherit;
    overflow-wrap: break-word;
}

.preview-selected {
  background-color: rgba(157, 213, 248, 0.712); 
  border:1px solid lightskyblue;
}

.preview:hover {
  border:1px solid lightskyblue;
}

</style>